<template>
   <div class="topContainer">
      <div class="pageHeader">Fatherhood Initiative</div>
      <div class="sectionInfo">
       <div class="sectionHeader">
         The Father Absence Crisis in America
        </div>
        <div class="sectionContent" style="text-align: center">
          <b-link href="http://www.fatherhood.org">fatherhood.org</b-link>
        <b-list-group horizontal="md">
         <b-list-group-item><img :src="pic1" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic2" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic3" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic4" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic5" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic6" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic7" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic8" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic9" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic10" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic11" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic12" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic13" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic14" class="imgSize"/></b-list-group-item>
         <b-list-group-item><img :src="pic15" class="imgSize"/></b-list-group-item>
        </b-list-group>
      </div>
     </div>
   </div>
</template>
<script>
export default {
  data: function () {
     return { 
       pic1 : require('@/assets/fatherhood_1.jpg'), pic2 : require('@/assets/fatherhood_2.jpg'), pic3 : require('@/assets/fatherhood_3.jpg'), 
       pic4 : require('@/assets/fatherhood_4.jpg'),pic5 : require('@/assets/fatherhood_5.jpg'), pic6 : require('@/assets/fatherhood_6.jpg'),
       pic7 : require('@/assets/fatherhood_7.jpg'), pic8 : require('@/assets/fatherhood_8.jpg'), pic9 : require('@/assets/fatherhood_9.jpg'), 
       pic10 : require('@/assets/fatherhood_10.jpg'),pic11 : require('@/assets/fatherhood_11.jpg'), pic12 : require('@/assets/fatherhood_12.jpg'),
       pic13 : require('@/assets/fatherhood_13.jpg'), pic14 : require('@/assets/fatherhood_14.jpg'), pic15 : require('@/assets/fatherhood_15.jpg')
     }
  }
}
</script>
<style scoped>
.topContainer{
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('~@/assets/pruning.jpg') no-repeat center center fixed;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
     background-size: cover;
    height: 60px;
    width: 100%;
    position: relative;
    z-index: 2;
    border-bottom: 2px solid black;
    box-shadow: 1px 1px #111;
}
.sectionHeader{
     font-size: 2vw;
     text-align: center
}
.imgSize {
   height: 200px;
   margin: 5px 5px;
}
.list-group{ 
  flex-wrap: wrap;
}
.list-group-item {
  padding: 10px;
  margin:10px;
}
.imgSize{
  height: 200px;
}
.sectionContent{
  margin-top:0px;
}
</style>
